function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\r\n    .firma{\r\n        fill: currentColor;\r\n        stroke-width: 0px;\r\n    }\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(123)",
  d: "m0 0h1125l1 3 20 7 19 10 17 12 15 14 8 8 10 13 12 20 8 18 6 23 2 22 1 47v219l-1 329-1 17 16-11 12-7 16-6 3-1h18l13 4 11 6 8 8 12-1 12-7 15-6 13-3h8l14 5 11 7 23 23 9 11 9 14 5 11 2 10 3 1-3 1-3 9-8 16-6 10-14 18-9 10-7 8-12 12-8 7-13 12-16 15-15 14-11 9-7 7-8 7-15 14-11 9-11 10-8 7-11 9-15 14-14 14-7 10 1 184v166l-1 153-1 25-1 10h-1079l-1-55-1-370v-738l1-95-2 1h-261l-9-2-9-9-2-5-1-23 1-8-1-31 1-19v-27l-1-43v-23l3-2 2 3 1-3 2-19 3-17 6-18 11-21 10-15 9-11 15-15 24-16 17-9 18-7h2zm1119 1m-971 32-7 1 2 1 1 4 9 11 4 2 2 4 9 13 8 14 10 22 5 17 2 21 1 28 1 425v969l7 1h360l642 1 2-1 1-5 1-383 1-61v-25l-4 2-14 10-12 11-8 7-10 9-11 9-12 11-11 9-12 11-8 7-20 18-8 7-15 14-12 11-8 7-13 12-8 7-16 15-15 13-10 9-8 7-5 4v2l-4 2-12 11-8 7-12 11-14 11-5 4-14 7-17 5-35 8-35 6-21 6-14 3-11-4-11-8-10-9-8-7-9-9-11-8-4-1-7 6-7 14-11 15-6 8-8 7-11 5-18 2-13-2-8-3-9-7-11-14-9-15-8-11-5-3-6 1-8 6-7 6-15 8-8 5-3 1h-8l-14-6-11-8-9-8h-5v2h-2l-10 17-9 15-8 11-3 3v2l-4 2-6 5-5 1-19-1-10-3-8-7-7-7-7-8-9-8-6-1-8 4-7 7-9 11-7 6-10 5h-8l-6-2-2-4 2-9 5-12 8-11 11-12 8-7 12-7 9-3h8l16 6 9 6 11 11 7 10 3 3 6-1 7-7 9-19 11-17 5-5 8-6 5-2h18l14 5 8 6 7 6 4 2h5v-2l4-2 8-6 11-8 12-4h19l10 3 11 7 8 9 10 14 10 13 8 8h5l8-6 8-10 10-16 10-15 4-5 10-6 6-2h13l13 5 10 7 17 16 4 4 4-1 4-5 12-36 8-25 8-21 10-15 9-10 8-8 8-7 9-9 8-7 13-12 8-7 11-10 8-7 14-12 16-15 12-11 26-24 20-18 11-9 16-15 10-9 11-9 9-9 11-9 9-9 10-8 16-15 8-7 11-10 11-9 6-5v-2l4-2 11-10 8-7 14-13 10-8 10-9 11-9 7-8 5-4v-2l4-2 5-10v-20l-2-4-5 2-10 9-8 8-2 1v2h-2v2l-4 2-10 9-15 14-2 1v2l-4 2-14 13-8 7-10 9-8 7-10 9-4 3v2l-4 2-10 9-8 7-14 13-14 10-10 5-6 1-6-2-4-5-1-3v-9l4-7 9-10 13-12 8-7 15-14 7-7 2-1v-2l4-2 10-10 8-7 12-11 10-8v-2l4-2 12-11 8-7 10-9 2-1v-2l4-2 15-13 26-22 9-9 3-5 1-454v-157l-1-37-2-18-4-15-5-12-9-15-9-11-11-11-11-8-15-9-15-6-22-4-24-2-59-1zm-117 1-18 2-21 6-16 8-14 10-7 6-7 8-11 13-8 14-7 19-3 15-2 23v150h243l1-1v-131l-1-34-2-15-7-21-8-16-8-11-9-10-9-9-14-10-15-8-13-4-14-3-11-1zm-149 123v9h1v-9zm-2 1m1423 610-9 3-16 8-12 9-13 12-6 9-4 10-3 16 1 4 11-6 10-8 9-9 11-9 11-10 8-7 5-4 7-8v-6l-3-3zm87 3-10 4-11 10 2 1 2 5 8 11 11 12 7 8 9 10 10 9 1-2h4l5-5 4-8 1-5v-7l-5-10-9-11-9-10-5-6-9-6zm-51 34-7 4-14 11-10 9-12 11-14 12-7 7-8 7-9 9-10 8-14 12-15 13-8 7-12 11-13 13-8 7-5 5 1 4 10 9 13 15 12 13 7 7 10 13 3 3 6 1 6-4 7-7 11-9 13-12 8-7 10-9 8-7 13-12 8-7 11-10 8-7 10-9 14-12 11-9 13-12 10-9 1-6-13-13-7-8-12-14-7-7-7-9-9-11zm-190 169-6 3-7 7-6 7-8 6-3 5 1 4 6 7 14 14 7 8 9 10 7 8 12 13 2 3 5-1 10-8 13-13 2-5-3-5-11-13-13-15-11-13-13-17-6-5zm-56 52-7 3-10 8-14 12-8 7-7 7-8 7-7 7-8 7-7 7-11 9-16 15-11 10-8 7-10 9-11 10-8 7-10 9-8 7-10 9-8 7-14 12-16 15-12 11-18 18-5 7 8 8 8 7 9 10 7 8 11 12 7 8 5 5 4 3 5-1 8-5 8-8 14-11 8-7v-2l4-2 15-14 8-7 10-9 13-12 8-7 20-18 8-7 13-11 10-9 15-14 11-9 13-13 8-7 10-9 11-9 14-12 15-14 5-6-6-4-7-8-10-11-9-11-14-14-8-10-6-7zm-268 259-4 8-10 27-8 21-1 3h14l29-5 15-4 5-3-4-8-8-9-13-17-12-13z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(625,804)",
  d: "m0 0h539l69 1 5 3 3 5 1 7-2 13-4 4-6 1-541 1-251-1-9-1-2-1-4-12v-11l2-6 2-1 29-1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(503,559)",
  d: "m0 0h709l24 1 3 7v22l-3 2-161 1h-644l-5-2-2-4v-23l1-3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(490,126)",
  d: "m0 0h147l31 1 15 3 8 5 6 9 3 12 2 25v65l-2 12-5 9-7 8-12 6-8 1-21 1-60 1h-86l-42-1-14-2-8-6-7-7-5-10-2-6-2-18v-54l1-16 5-16 6-9 11-8 7-3 5-1zm-31 32-1 2-1 14v54l1 19 3 3h59l144-1 3-1 1-8 1-73-1-7-4-1-158-1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(465,682)",
  d: "m0 0h452l54 1 9 2 3 5v18l-3 5-2 1-55 1h-487l-7-1-3-3-2-8v-18l2-2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(990,435)",
  d: "m0 0h122l86 1 36 1 5 2 1 1 1 14-1 12-3 3-3 1-82 1h-229l-88-1-5-3-2-7v-12l4-11 64-1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(505,436)",
  d: "m0 0h206l21 1 1 1 1 7v19l-3 5-2 1h-298l-4-2-3-8v-17l2-4 2-1 14-1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(744,1423)",
  d: "m0 0h9l5 5v15l-2 8-9 4-28 4-56 5-43 3-71 4h-26l-3-3v-13l4-11 6-5 17-2 60-5 90-6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(428,927)",
  d: "m0 0h149l59 1 8 2 3 4 1 13-1 8-5 3-23 1-49 1h-108l-32-1-5-3-1-3-1-12 1-10z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(1080,683)",
  d: "m0 0h143l13 1 3 3 1 5v9l-1 10-4 4h-99l-49-1-11-1-2-5v-17l3-7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(612,1154)",
  d: "m0 0h49l30 1 2 3v26l-3 3-6 1h-125l-7-1-5-8v-14l4-10z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(427,1156)",
  d: "m0 0h54l5 2 2 6v19l-3 3-4 1h-41l-11-1-4-2-2-4v-19l2-4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(762,1156)",
  d: "m0 0h32l9 2 2 4v15l-4 7-4 2-8 1h-20l-10-3-5-5-1-11 3-9 2-2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(1495,784)",
  d: "m0 0"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(0,149)",
  d: "m0 0"
}), /*#__PURE__*/React.createElement("path", {
  className: "firma",
  transform: "translate(1263)",
  d: "m0 0 2 1z"
}));

var SvgFirma = function SvgFirma(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "firma",
    viewBox: "0 0 1600 1600",
    width: 100,
    height: 100,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFirma, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/firma.42ca5c64.svg";
export { ForwardRef as ReactComponent };